import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { UrlParamKeys } from '~commonInfra/url/UrlParamKeys';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { setOrderAction } from '~src/spacesPlatform/actions/SetOrderAction';
import { getOrderClausesFromQueryParam } from '~src/spacesPlatform/components/Explorer/ExplorerUrlBindings';
import { getDefaultOrderForSimulationSubSpace } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

import { EnterSimulationSubspaceReduxAction } from '../actions/EnterSimulationSubspaceAction';

export function* handleEnterSimulationSubspace(action: EnterSimulationSubspaceReduxAction): SagaIterator {
  try {
    const spaceInfo: SpaceInfo = {
      item: action.simulationDetailInfo,
      spaceType: 'simulation',
      subspaceName: action.subspaceName,
    };
    yield put(enterSpace(spaceInfo));
      const hashQuery: any = WindowLocationService.getHashQueryObject();
      const orderFromQuery = getOrderClausesFromQueryParam(
        hashQuery[UrlParamKeys.Order],
        getDefaultOrderForSimulationSubSpace(spaceInfo)
      );
      yield put(setOrderAction(orderFromQuery));
      yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
